// Backbone View for tooltips
var $ = jQuery;
var GroupTooltipRating = Backbone.View.extend({
    initialize: function (options) {
        var layout = model.get('layout');
        // we set current block on call, so we need options array to bind data properly
        this.options = options;
        _.bindAll(this, 'bindings');
    },
    bindings: function () {
        var layout = model.get('layout');
        var result = {};
        var field = this.options.field_name;
        var field_model = 'styles.' + layout + '.' + field;
        result['[name="group_' + field + '_text_color"]'] = field_model + '_text_color'; // skill bar text color
        result['[name="group_' + field + '_bar_color"]'] = field_model + '_bar_color'; // skill bar color
        result['[name="group_' + field + '_font_size"]'] = field_model + '_font_size'; // skill bar size
        result['[name="group_' + field + '_size"]'] = field_model + '_size'; // skill bar size
        result['[name="group_' + field + '_type"]'] = field_model + '_type'; // skill type
        result['[name="group_' + field + '_bold"]'] = field_model + '_bold'; // block bold
        result['[name="group_' + field + '_italic"]'] = field_model + '_italic'; // block italic
        result['[name="group_' + field + '_text_transform"]'] = field_model + '_text_transform'; // block text transform
        result['[name="group_' + field + '_align"]'] = field_model + '_align'; // block align
        result['[name="group_' + field + '_top_margin"]'] = field_model + '_top_margin'; // block top margin
        result['[name="group_' + field + '_source"]'] = field_model + '_source'; // block top margin
        result['[name="group_' + field + '_scale"]'] = field_model + '_scale'; // block top margin
        result['[name="group_' + field + '_icon_count"]'] = field_model + '_icon_count';

        result['.btn-bold'] = {
            observe: field_model + '_bold',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                if(!!+val){
                    $el.addClass('active');
                }
            }
        };
        result['.btn-italic'] = {
            observe: field_model + '_italic',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                if(!!+val){
                    $el.addClass('active');
                }
            }
        };
        result['.btn-group-text-transform'] = {
            observe: field_model + '_text_transform',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_text_transform_' + val).addClass('active');
            }
        };
        result['.btn-group-align'] = {
            observe: field_model + '_align',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_align_' + val).addClass('active');
            }
        };

        result['.btn-group-type'] = {
            observe: field_model + '_type',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_type_' + val).addClass('active');
            }
        };

        result['.btn-icon'] = {
            observe: [
                field_model + '_icon'
            ],
            update: function($el, val, model, options){
                if(val == 'replace'){
                    val = 'cog';
                }
                $el.find('.icon-main use').attr('xlink:href', '#aet_icon-' + val);
            }
        };

        result['.icon-list'] = {
            observe: field_model + '_icon',
            update: function($el, val, model, options){
                $el.find('.glyph').removeClass('active');
                $el.find('[data-name="' + val + '"]').addClass('active');
            }
        };

        return result;
    },
    render: function(){
        this.stickit();
        return this;
    },
    close: function(){
        this.unstickit();
    }
});